import React, { Component } from "react";
import Select from "react-select";
import PropTypes from 'prop-types';
import {
  Grid,
  Row,
  Col,
  Panel,
  Button,
  Tabs,
  Tab,
  ButtonToolbar,
  Breadcrumb,
  Dropdown,
  MenuItem,
  Input,
} from "react-bootstrap";
import { Translate } from "react-redux-i18n";
import { Toolbar, Data } from "react-data-grid-addons";
import ReactDataGrid from "react-data-grid";
import { dispatchBindWithSCMUser } from './redux';

const propTypes = {
  // selectedOrders: PropTypes.array
}

const defaultProps = {
  // selectedOrders: []
}

export class DispatcherBindModal extends Component {
  constructor() {
    super();
    this.state = {
      selectedUser: '',
    };
  }

  handleOnSubmit = (e) => {
    const {
      selectedMobileUserId,
      handleDispatcherBindSuccess,
    } = this.props;
    const {
      selectedUser,
    } = this.state;

    const payload = {
      BaseUserId: selectedUser.value || selectedUser,
      MobileUserIds: [selectedMobileUserId],
    };

    dispatchBindWithSCMUser(payload, handleDispatcherBindSuccess);
  };

  handleDriverSelect = (selectedUser) => this.setState({ selectedUser });

  render() {
    const {
      selectedUser,
    } = this.state;
    const scmUsers = this.props.scmUsers.map(user => ({
      label: `${user.FirstName || ''} ${user.LastName || ''}`,
      value: user.BaseUser_id,
    }))
    return (
      <div>
        <Row style={{ marginBottom: "12px" }}>
          <Col sm={3}>
            <label style={{ float: 'right' }}>
              <Translate value="scm_user" />:
            </label>
          </Col>
          <Col sm={9}>
            <Dropdown>
              <Dropdown.Toggle
                style={{
                  width: "300px",
                  backgroundColor: "white",
                  border: "1px solid #555555",
                  color: "black",
                  fontWeight: "400",
                }}
              >
                {selectedUser.label || selectedUser}
              </Dropdown.Toggle>
              <Dropdown.Menu className="super-colors">
                {scmUsers.map((el) => {
                  return (
                    <MenuItem onClick={() => this.handleDriverSelect(el)} style={{
                      width: "300px",
                      backgroundColor: "white",
                      color: "black",
                      fontWeight: "400",
                    }}>
                      {el.label}
                    </MenuItem>
                  );
                })}
              </Dropdown.Menu>
            </Dropdown>
          </Col>
        </Row>

        <Row className="centerStyle" style={{ marginTop: "50px" }}>
          <Button
            bsStyle="success"
            onClick={(e) => {
              this.handleOnSubmit(e);
            }}
            disabled={!this.state.selectedUser}
          >
            <Translate value="bind" />
          </Button>
        </Row>
      </div>
    );
  }
}

DispatcherBindModal.propTypes = propTypes
DispatcherBindModal.defaultProps = defaultProps

export default DispatcherBindModal;



// WEBPACK FOOTER //
// ./master/jsx/components/Common/modals/userManagement/dispatcherBind/dispatcherBindModal.jsx